<template>
  <v-card class="modern-card" elevation="0">
    <v-card-title class="px-6 py-4">
      <v-icon left color="accent" class="mr-3" small>{{ icon }}</v-icon>
      <span class="body-1 font-weight-bold primary--text">{{ title }}</span>
    </v-card-title>

    <v-divider />

    <v-card-text class="px-6 py-5">
      <div class="d-flex align-center text-caption grey--text mb-3">
        <v-icon x-small class="mr-2">fas fa-clock</v-icon>
        Última sincronización:
        <span class="ml-1 font-weight-medium">
          {{ lastSync ? formatDate(lastSync) : 'Nunca' }}
        </span>
      </div>

      <div class="d-flex align-center">
        <v-btn
          color="accent"
          :loading="syncInProgress"
          :disabled="disabled || syncInProgress"
          @click="$emit('sync')"
          class="text-none"
          small
        >
          <v-icon left x-small>fas fa-sync</v-icon>
          Sincronizar
        </v-btn>
        <span v-if="syncInProgress" class="ml-3 text-caption accent--text">
          Sincronizando...
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SyncCatalogCard',
  props: {
    title: { type: String, required: true },
    icon: { type: String, required: true },
    syncInProgress: { type: Boolean, default: false },
    lastSync: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return 'Nunca'
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
}
</script>
